import { render } from "./RegistrationAlertListView.vue?vue&type=template&id=3ed3fc2e&scoped=true"
import script from "./RegistrationAlertListView.vue?vue&type=script&lang=js"
export * from "./RegistrationAlertListView.vue?vue&type=script&lang=js"

import "./RegistrationAlertListView.vue?vue&type=style&index=0&id=3ed3fc2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed3fc2e"]])

export default __exports__